import { Col, Label, CustomInput, FormFeedback, FormGroup } from "reactstrap"
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

/*******************************************************************************/
// Componente específico para manipular o RadioForm de Avaliação Formativa
/*******************************************************************************/

const RadioFormAvaliacaoFormativa = (props) => {
    const [checked, setChecked] = useState(props.valorPadrao || "0");

    useEffect(() => {
        if (props.valorPadrao !== undefined) {
            setChecked(props.valorPadrao.toString());
        }
    }, [props.valorPadrao]);

    const onChange = (event) => {
        props.onChange(props.name, event.target.value);
        setChecked(event.target.value);
    };

    const gerarId = () => (((1 + Math.random()) * 0x1000000) | 0).toString(16).substring(1);

    return (
        <Col {...props.style?.col} className="form-col">
            <FormGroup className="form-group">
                <Label className={props.style?.labelClass}>
                    {props.label}
                </Label>
                
                <div className="d-flex align-items-center" style={{ marginLeft: '0.6rem', gap: '1rem', marginBottom: '0.5rem' }}>
                    {props.options.map((elemento, indice) => (
                        <div key={props.label + indice} style={{ marginRight: '1rem', display: 'flex', alignItems: 'center' }}>
                            <CustomInput
                                type="radio"
                                id={gerarId()}
                                name={props.name}
                                label={elemento.label}
                                value={elemento.value}
                                checked={checked === elemento.value}
                                onChange={onChange}
                            />
                        </div>
                    ))}
                </div>
            </FormGroup>
        </Col>
    );
};

RadioFormAvaliacaoFormativa.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    valorPadrao: PropTypes.string,
    style: PropTypes.object
};

RadioFormAvaliacaoFormativa.defaultProps = {
    style: {
        col: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 },
        labelClass: ""
    }
};

export default RadioFormAvaliacaoFormativa;
